import React, {PureComponent} from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"
import {get} from "lodash"

import {injectValidationStatusHandler} from "@irati-web/insights/src/graph/cycleValidationStatusHandler"

import {Query as QueryComponent} from "../"
import schedule, {scheduleParams} from "../../gql/schedule"


const query = gql`
 query ScheduleList(
    $tenant: String!,
    $orderBy: String,
    $orderDirection: String,
    $status: String,
    $limit: Int,
    $offset: Int
    ${scheduleParams}
  ) {
    schedules(tenant: $tenant, orderBy: $orderBy, orderDirection: $orderDirection, status: $status, limit: $limit, offset: $offset){
      results {
        ${schedule}
      }
      total
    }
  }
`


class SchedulesQuery extends PureComponent {
  static propTypes = {
    children: PropTypes.func.isRequired
  }

  parseData = (data) => {
    const results = get(data, "schedules.results", []).map(injectValidationStatusHandler)
    const total = get(data, "schedules.total", null)
    return {...data, results, total}
  }

  render() {
    const {children} = this.props
    return (
      <QueryComponent {...this.props} query={query}>
        {({data, ...apolloState}) => {
          return children({
            data: this.parseData(data),
            ...apolloState
          })
        }}
      </QueryComponent>
    )
  }
}

export default SchedulesQuery
